import CssBaseline from '@mui/material/CssBaseline';
import { StrictMode } from 'react';

import {
  CacheProvider,
  GlobalStylesProvider,
  ThemeProvider,
} from 'app/providers';
import { AnalyticsProvider } from 'applications/GSP/app/providers/AnalyticsProvider';
import { PrefetchProvider } from 'applications/GSP/app/providers/PrefetchProvider';
import { RouterProvider } from 'applications/GSP/app/providers/RouterProvider';
import { StoreProvider } from 'applications/GSP/app/providers/StoreProvider';
import { TranslationProvider } from 'applications/GSP/app/providers/TranslationProvider';

import type { FC } from 'react';

const GSP: FC = () => (
  <StrictMode>
    <ThemeProvider>
      <CssBaseline>
        <GlobalStylesProvider>
          <StoreProvider>
            <AnalyticsProvider>
              <PrefetchProvider>
                <TranslationProvider>
                  <CacheProvider>
                    <RouterProvider />
                  </CacheProvider>
                </TranslationProvider>
              </PrefetchProvider>
            </AnalyticsProvider>
          </StoreProvider>
        </GlobalStylesProvider>
      </CssBaseline>
    </ThemeProvider>
  </StrictMode>
);

export default GSP;
